import { useEffect, useState } from "react";
import { Button, Label, Menu, Tab, TabProps } from "semantic-ui-react";
import "./styles.module.css";
import styles from "./styles.module.css";
import { useNavigate } from "react-router-dom";
import AllProducts from "./tables/AllProducts";
import { FilterModal } from "../../../app/common/helpers";
import { ReactComponent as SvgSearchIcon } from "../../../assets/searchIcon.svg";
import { ReactComponent as PlusCircle } from "../../../assets/plusCircle.svg";
import { useStore } from "../../../app/stores/store";
import Loading from "../../../app/layout/Loading";
import { observer } from "mobx-react-lite";
import TablePlaceholder from "./tables/TablePlaceholder";

const ProductsIndex = () => {
  const [currentFilter, setCurrentFilter] = useState({ value: "", code: 0 });
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();
  const { productStore } = useStore();
  const {
    loadingInitial,
    changeProductVisibility,
    deleteProduct,
    loading,
    getVendorProducts,
    vendorProductList,
    vendorApprovedProductList,
    vendorDisapprovedProductList,
    vendorPublishedProductList,
    vendorUnpublishedProductList,
  } = productStore;
  const statuses = [
    { name: "Newest to Oldest", code: 0 },
    { name: "Oldest to Newest", code: 1 },
    { name: "Online", code: 2 },
    { name: "Offline", code: 3 },
  ];

  const handleSearchChange = (
    e: React.ChangeEvent<HTMLInputElement>, 
  ) => {
    setCurrentPage(1); // Reset the page to 1
    setSearchTerm(e.target.value); // Update the search term
    if(e.target.value){
      getVendorProducts(searchTerm);
    }else {
      getVendorProducts("");
    }
  };

  const filteredVendorProductList = vendorProductList
    // .filter((val) => {
    //   if (searchTerm !== "") {
    //     // getVendorProducts(searchTerm);
    //     return val;
    //   } else if (
    //     val.productName != null &&
    //     val.productName.toLowerCase().includes(searchTerm.toLowerCase())
    //   ) {
    //     return val;
    //   } else {
    //     return null;
    //   }
    // })
    .filter((fil) => {
      if (currentFilter.code >= 100) {
        return fil;
      } else if (currentFilter.code === 2) {
        return fil.isEnable;
      } else if (currentFilter.code === 3) {
        return !fil.isEnable;
      }
      return fil;
    })
    .sort(function (x, y) {
      if (currentFilter.value === "Newest to Oldest") {
        let b = new Date(x.dateCreated).getTime(),
          a = new Date(y.dateCreated).getTime();
        return a - b;
      } else if (currentFilter.value === "Oldest to Newest") {
        let b = new Date(x.dateCreated).getTime(),
          a = new Date(y.dateCreated).getTime();
        return b - a;
      } else {
        let b = new Date(x.dateCreated).getTime(),
          a = new Date(y.dateCreated).getTime();
        return a - b;
      }
    });

  const filteredVendorApprovedProductList = vendorApprovedProductList
    // .filter((val) => {
    //   if (searchTerm === "") {
    //     return val;
    //   } else if (
    //     val.productName != null &&
    //     val.productName.toLowerCase().includes(searchTerm.toLowerCase())
    //   ) {
    //     return val;
    //   } else {
    //     return null;
    //   }
    // })
    .filter((fil) => {
      if (currentFilter.code === 100) {
        return fil;
      } else if (currentFilter.code === 2) {
        return fil.isEnable;
      } else if (currentFilter.code === 3) {
        return !fil.isEnable;
      }
      return fil;
    })
    .sort(function (x, y) {
      if (currentFilter.value === "Newest to Oldest") {
        let b = new Date(x.dateCreated).getTime(),
          a = new Date(y.dateCreated).getTime();
        return a - b;
      } else if (currentFilter.value === "Oldest to Newest") {
        let b = new Date(x.dateCreated).getTime(),
          a = new Date(y.dateCreated).getTime();
        return b - a;
      } else {
        let b = new Date(x.dateCreated).getTime(),
          a = new Date(y.dateCreated).getTime();
        return a - b;
      }
    });

  const filteredVendorDisapprovedProductList = vendorDisapprovedProductList
    // .filter((val) => {
    //   if (searchTerm === "") {
    //     return val;
    //   } else if (
    //     val.productName != null &&
    //     val.productName.toLowerCase().includes(searchTerm.toLowerCase())
    //   ) {
    //     return val;
    //   } else {
    //     return null;
    //   }
    // })
    .filter((fil) => {
      if (currentFilter.code === 100) {
        return fil;
      } else if (currentFilter.code === 2) {
        return fil.isEnable;
      } else if (currentFilter.code === 3) {
        return !fil.isEnable;
      }
      return fil;
    })
    .sort(function (x, y) {
      if (currentFilter.value === "Newest to Oldest") {
        let b = new Date(x.dateCreated).getTime(),
          a = new Date(y.dateCreated).getTime();
        return a - b;
      } else if (currentFilter.value === "Oldest to Newest") {
        let b = new Date(x.dateCreated).getTime(),
          a = new Date(y.dateCreated).getTime();
        return b - a;
      } else {
        let b = new Date(x.dateCreated).getTime(),
          a = new Date(y.dateCreated).getTime();
        return a - b;
      }
    });

  const filteredVendorPublishedProductList = vendorPublishedProductList
    // .filter((val) => {
    //   if (searchTerm === "") {
    //     return val;
    //   } else if (
    //     val.productName != null &&
    //     val.productName.toLowerCase().includes(searchTerm.toLowerCase())
    //   ) {
    //     return val;
    //   } else {
    //     return null;
    //   }
    // })
    .filter((fil) => {
      if (currentFilter.code === 100) {
        return fil;
      } else if (currentFilter.code === 2) {
        return fil.isEnable;
      } else if (currentFilter.code === 3) {
        return !fil.isEnable;
      }
      return fil;
    })
    .sort(function (x, y) {
      if (currentFilter.value === "Newest to Oldest") {
        let b = new Date(x.dateCreated).getTime(),
          a = new Date(y.dateCreated).getTime();
        return a - b;
      } else if (currentFilter.value === "Oldest to Newest") {
        let b = new Date(x.dateCreated).getTime(),
          a = new Date(y.dateCreated).getTime();
        return b - a;
      } else {
        let b = new Date(x.dateCreated).getTime(),
          a = new Date(y.dateCreated).getTime();
        return a - b;
      }
    });

  const filteredVendorUnpublishedProductList = vendorUnpublishedProductList
    // .filter((val) => {
    //   if (searchTerm === "") {
    //     return val;
    //   } else if (
    //     val.productName != null &&
    //     val.productName.toLowerCase().includes(searchTerm.toLowerCase())
    //   ) {
    //     return val;
    //   } else {
    //     return null;
    //   }
    // })
    .filter((fil) => {
      if (currentFilter.code === 100) {
        return fil;
      } else if (currentFilter.code === 2) {
        return fil.isEnable;
      } else if (currentFilter.code === 3) {
        return !fil.isEnable;
      }
      return fil;
    })
    .sort(function (x, y) {
      if (currentFilter.value === "Newest to Oldest") {
        let b = new Date(x.dateCreated).getTime(),
          a = new Date(y.dateCreated).getTime();
        return a - b;
      } else if (currentFilter.value === "Oldest to Newest") {
        let b = new Date(x.dateCreated).getTime(),
          a = new Date(y.dateCreated).getTime();
        return b - a;
      } else {
        let b = new Date(x.dateCreated).getTime(),
          a = new Date(y.dateCreated).getTime();
        return a - b;
      }
    });

    const handleTabChange = (e: React.SyntheticEvent, data: TabProps) => {
      setCurrentPage(1);
    };

  const panes = [
    {
      menuItem: (
        <Menu.Item key={"all"}>
          <Label
            style={{
              fontFamily: "Montserrat",
              fontSize: "13px",
              background: "none",
              color: "rgb(4 4 4 / 87%)",
              padding: "0px",
            }}
          >
            All Products
          </Label>
        </Menu.Item>
      ),
      render: () =>
        loadingInitial === "loading" ? (
          <TablePlaceholder />
        ) : (
          <AllProducts
            productList={filteredVendorProductList}
            deleteProduct={deleteProduct}
            loading={loading}
            changeProductVisibility={changeProductVisibility}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        ),
    },
    {
      menuItem: (
        <Menu.Item
          key={"approved"}
          style={{
            fontFamily: "Montserrat",
            fontSize: "13px",
          }}
        >
          Approved by Admin
          <Label circular color={"red"} size={"mini"}>
            {filteredVendorApprovedProductList.length}
          </Label>
        </Menu.Item>
      ),
      render: () =>
        loadingInitial === "loading" ? (
          <TablePlaceholder />
        ) : (
          <AllProducts
            productList={filteredVendorApprovedProductList}
            deleteProduct={deleteProduct}
            loading={loading}
            changeProductVisibility={changeProductVisibility}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        ),
    },
    {
      menuItem: (
        <Menu.Item
          key={"disapproved"}
          style={{
            fontFamily: "Montserrat",
            fontSize: "13px",
          }}
        >
          Disapproved by Admin
          <Label circular color={"red"} size={"mini"}>
            {filteredVendorDisapprovedProductList.length}
          </Label>
        </Menu.Item>
      ),
      render: () =>
        loadingInitial === "loading" ? (
          <TablePlaceholder />
        ) : (
          <AllProducts
            productList={filteredVendorDisapprovedProductList}
            deleteProduct={deleteProduct}
            loading={loading}
            changeProductVisibility={changeProductVisibility}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        ),
    },
    {
      menuItem: (
        <Menu.Item
          key={"published"}
          style={{
            fontFamily: "Montserrat",
            fontSize: "13px",
          }}
        >
          Published
          <Label circular color={"red"} size={"mini"}>
            {filteredVendorPublishedProductList.length}
          </Label>
        </Menu.Item>
      ),
      render: () =>
        loadingInitial === "loading" ? (
          <TablePlaceholder />
        ) : (
          <AllProducts
            productList={filteredVendorPublishedProductList}
            deleteProduct={deleteProduct}
            loading={loading}
            changeProductVisibility={changeProductVisibility}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        ),
    },

    {
      menuItem: (
        <Menu.Item
          key={"unpublished"}
          style={{ fontFamily: "Montserrat", fontSize: "13px" }}
        >
          Unpublished
          <Label circular color={"red"} size={"mini"}>
            {filteredVendorUnpublishedProductList.length}
          </Label>
        </Menu.Item>
      ),
      render: () =>
        loadingInitial === "loading" ? (
          <TablePlaceholder />
        ) : (
          <AllProducts
            productList={filteredVendorUnpublishedProductList}
            deleteProduct={deleteProduct}
            loading={loading}
            changeProductVisibility={changeProductVisibility}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        ),
    },
  ];

  useEffect(() => {
    getVendorProducts(searchTerm);
    const getPreviousPageBeforeUpdate = JSON.parse(sessionStorage.getItem("currentPage")!)
    if(getPreviousPageBeforeUpdate) {
      setCurrentPage(getPreviousPageBeforeUpdate);
      sessionStorage.removeItem("currentPage")
    }
  }, []);
  return (
    <div className={styles.page}>
      {(loadingInitial === "loading" || loading) && <Loading />}

      <div className={styles.header}>
        Products
        <div className={styles.searchAndFilter}>
          <div>
            <div className={`${styles.hassearch}`}>
              {/* <span className="fa fa-search form-control-feedback"></span> */}
              <SvgSearchIcon className={styles.formcontrolfeedback} />
              <input
                type="text"
                className={styles.formcontrol}
                placeholder="Search Products, Product name"
                onChange={(e) => {
                  handleSearchChange(e)
                }}
              />
            </div>
          </div>
          <FilterModal
            options={[
              ...[...statuses].map((status, index) => ({
                code: index,
                value: status.name,
              })),
              { value: "None", code: 100 },
            ]}
            onSelect={(e) => setCurrentFilter({ value: e.value, code: e.code })}
            selected={currentFilter.code}
          />
          <Button
            positive
            className={styles.activate}
            onClick={() => navigate("/vendor/products/new-product")}
          >
            <div className={styles.positive}>
              <span>New Product</span>
              <PlusCircle />
            </div>
          </Button>
        </div>
      </div>

      <div className={styles.tableSection}>
        <div className="section">
          <Tab
            menu={{ secondary: true, pointing: true }}
            panes={panes}
            onTabChange={handleTabChange} 
            // className={styles.paneMenu}
          />
        </div>
      </div>
    </div>
  );
};

export default observer(ProductsIndex);
